import React from 'react';

export default props => (
  <div className="advanced-management-terms--mobile">
    <p>Olá!</p>
    <p>Aqui, você pode indicar familiares e amigos que desejam ter contas vinculadas a você.</p>
    <p>
      O vínculo entre as contas deve ser acordado diretamente por você e pelo participante 
      indicado. Com o vínculo ativo, você receberá em sua conta os pagamentos das milhas 
      negociadas nas contas vinculadas.
    </p>
    <h5>Como Funciona:</h5>
    <ol>
      <li>Você indica um participante.</li>
      <li>O participante solicita o vínculo de conta e envia a documentação dele.</li>
      <li>Você aprova o pedido de vínculo e envia a sua documentação.</li>
      <li>A MaxMilhas analisa todos os documentos enviados.</li>
      <li>Caso esteja tudo certo, o vínculo de vocês será ativado.</li>
    </ol>
    <h5>Antes de começar</h5>
    <span>Você vai precisar nos enviar:</span>
    <ul>
      <li>Documento de identificação com foto (frente e verso).</li>
      <li>Selfie segurando o documento ao lado do rosto.</li>
      <li>Declaração de Vínculo assinada e digitalizada.</li>
    </ul>
  </div>
)